import React, { FC } from "react";
import style from "./style.scss";

export interface ModularLayoutProps {
    children?: JSX.Element[] | JSX.Element;
}

/**
 * Layout with where section tags have special styling.
 *
 * The layout exposes the background behind it and each section
 * tag is an floating card on top of it.
 *
 * @param props
 */
export const ModularLayout: FC<ModularLayoutProps> = (props: ModularLayoutProps) => {
    return <div className={style.layout}>
        <div className={style.content}>
            {props.children}
        </div>
        {/* <SiteFooter /> */}
    </div>;
};
